// @ts-nocheck
import React from 'react';
//@ts-ignore
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
//@ts-ignore
import PortalModal from './../portal-modal/./portal-modal';
//@ts-ignore
import {FindFromParse} from './../../themes/kent/utilities/parse';
//@ts-ignore
import {GoogleMapsApiKey,GeneralAssetUrl} from './../../themes/kent/utilities/constants';

interface IProps {
  brand?:string;
  google?:any;
  map?:any;
  Map?:any;
  zoom?:any;
  hideSearchBar?:any;
  highlightPreferredRetailers?:any;
}

interface IState {
  retailers?:any;
  keyRefresh?:any;
  mapCenter?:any;
  zoom?:any;
  activeRetailer?:any;
  modalActive?:any;
}

/**
 *
 * DealerMap Component
 * @extends {React.Component}
 */
 //@ts-ignore
class DealerMap extends React.Component<IProps> {
  public state: IState;

  constructor(props:IProps) {
      super(props);
      this.state = ({
        retailers:null,
        keyRefresh:0,
        zoom:10,
        mapCenter:{lat: 37.3610511, lng: -121.8684047}
      })
  }
  public componentDidUpdate(prevProps) {
    if (this.props !== prevProps.map) this.renderAutoComplete();
  }
  public componentDidMount = async() => {
    //todo replace with real code
    console.log('at the dealer map')
    var lang = 'en';
    var mapCenter = {lat: 37.3610511, lng: -121.8684047}
    if(lang == 'de'){
      mapCenter = {lat: 51.1578213, lng: 8.2121462}
    }
    if(lang == 'au'){
      mapCenter = {lat: -33.865143, lng: 151.209900}
    }
    let barefootbrand = false;
    if(this.props.brand == "fatsac" || this.props.brand == "barefootinternational"){
      barefootbrand = true
      let results = await FindFromParse("fatsacRetailers",[{'method':'limit','value':5000}]);
      if(results){
        console.log(results)
        this.setState({
          'brand':this.props.brand,
          'zoom':10,
          'retailers':results,
          'mapCenter':mapCenter,
          'activeRetailer':results[0]
        })
      }
    } else{
      let results = await FindFromParse("Retailers",[{'method':'contains','key':'site','value':this.props.brand},{'method':'limit','value':5000}]);
      if(results){
        console.log(results)
        this.setState({
          'brand':this.props.brand,
          'zoom':10,
          'retailers':results,
          'mapCenter':mapCenter,
          'activeRetailer':results[0]
        })
      }
    }

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  public showPosition = (position:any) => {
    console.log(position)
    if(position){
      let mapCenter = {lat: position.coords.latitude, lng: position.coords.longitude}
      this.setState({mapCenter:mapCenter})
    }

  }

  public onSubmit(e:any) {
     e.preventDefault();
   }

  public renderAutoComplete = () => {
    const { google, map } = this.props;
    if (!google || !map){
      return false
    } else{
      let autocomplete:any = new google.maps.places.Autocomplete(this.autocomplete);
      autocomplete.bindTo('bounds', map);
      autocomplete.addListener('place_changed', () => {
        console.log('changed')
        const place = autocomplete.getPlace();
        console.log(place)
        if(place.geometry){
          this.setState({
            'mapCenter':place.geometry.location
          })
        }
      });
      return false
    };
  }

  public onMarkerClick = (retailer:any) => {
    var keyRefresh = this.state.keyRefresh +1;
    this.setState({
      retailerClicked:true,
      activeRetailer:retailer,
      modalActive:true,
      keyRefresh:keyRefresh
    })
  }
  public modalDismissed = (retailer:any) =>{
    var keyRefresh = this.state.keyRefresh +1;
    this.setState({
      retailerClicked:false,
      modalActive:false,
      keyRefresh:keyRefresh
    })
  }
  public trackDeepLink = (name:any, webAddress:any) => {
    var link = webAddress;
    window.open(link);
  }

  public render(): JSX.Element {
    if(!this.state.retailers) return <span />;
    let webAddress = "";
    if(this.state.activeRetailer){
       webAddress = this.state.activeRetailer.attributes.website;
      if(this.state.activeRetailer.attributes.website){
        if(this.state.activeRetailer.attributes.website.indexOf('http://') == -1 && this.state.activeRetailer.attributes.website.indexOf('https://') == -1 ){
          webAddress = 'http://'+webAddress;
        } else {
          webAddress = this.state.activeRetailer.attributes.website;
        }
      }
    }
    console.log(this.props.google)
    //@ts-ignore
    return (
      <div className="full-height full-width light-grey-background relative">
        {this.state.activeRetailer &&
          <PortalModal
            key={this.state.keyRefresh}
            modalActive={this.state.modalActive}
            modalHidden={this.modalDismissed}
            content={
              <div className="centered-text primary-background small-max-width-container small-padding">
                {this.state.activeRetailer.attributes.name && <h4>{this.state.activeRetailer.attributes.name}</h4>}
                {this.state.activeRetailer.attributes.street && <p className="text-color-secondary"><b>Address:</b> {this.state.activeRetailer.attributes.street+', '+this.state.activeRetailer.attributes.city+', '+this.state.activeRetailer.attributes.postalCode}</p>}
                {this.state.activeRetailer.attributes.phone && <p className="text-color-secondary"><b>Phone:</b> {this.state.activeRetailer.attributes.phone}</p>}
                {this.state.activeRetailer.attributes.website && <div className="button primary-color-background white" onClick={() => this.trackDeepLink(this.state.activeRetailer.attributes.name, webAddress)} style={{"cursor":"pointer"}}>
                  {'Website'}
                </div>}
              </div>
            } />
        }
        {!this.props.hideSearchBar &&
          <form onSubmit={this.onSubmit}>
            <div className="row tiny-padding black-background full-width" style={{position:"absolute", zIndex:2}}>
              <div className="small-12 medium-12">
                <input
                  placeholder="Enter a location"
                  ref={ref => (this.autocomplete = ref)}
                  type="text"
                  style={{borderRadius:'0px',backgroundColor:'rgba(255,255,255,1)'}}
                />
              </div>
            </div>
          </form>
        }
        {this.props.google && this.state.zoom && this.state.mapCenter &&
          <Map
            google={this.props.google}
            zoom={this.state.zoom}
            initialCenter={this.state.mapCenter}
            center={this.state.mapCenter}
            >
            {this.state.retailers.map((retailer,index) =>{
            let icon = null;
            if(this.props.preferredRetailersOnly){
              if(retailer.attributes.shreducationGroup == "gold"){
                icon = GeneralAssetUrl+this.props.brand+"-map-icon-gold.png"
              } else if(retailer.attributes.shreducationGroup == "silver"){
                  icon = GeneralAssetUrl+this.props.brand+"-map-icon-silver.png"
              }
            }
            else if(this.props.highlightPreferredRetailers){
              if(retailer.attributes.shreducationGroup == "gold"){
                icon = GeneralAssetUrl+this.props.brand+"-map-icon-gold.png"
              } else if(retailer.attributes.shreducationGroup == "silver"){
                icon = GeneralAssetUrl+this.props.brand+"-map-icon-silver.png"
              } else{
                icon = GeneralAssetUrl+this.props.brand+"-map-icon.png"
              }
            }
            else{
              icon = GeneralAssetUrl+this.props.brand+"-map-icon.png"
            }
            console.log(icon)
            if(icon){
              return(
                <Marker
                  icon={{url:icon}}
                  key={retailer.id}
                  position={{ lat: retailer.attributes.lattitude, lng: retailer.attributes.longitude }}
                  onClick={() => this.onMarkerClick(retailer)}
                  name={retailer.attributes.name}
                  retailer={retailer}
                />
              )
            }
          })}
          </Map>
        }
      </div>
    );
  }
}
//@ts-ignore
const MapWrapper = (props:any) => (
  <Map className="map" google={props.google} visible={false}>
    <DealerMap {...props} />
  </Map>
);

//@ts-ignore
export default GoogleApiWrapper({
  apiKey: (GoogleMapsApiKey)
})(MapWrapper)
